import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import { ReactComponent as IconRocket } from "@Icons/colored/rocket.svg";
import { ReactComponent as IconTruck } from "@Icons/colored/truck.svg";
import { formatDeliveryDates } from "@Utils/date";
import "./style.scss";

interface Props {
  deliveryDates: string[];
}

const CartEstimatedDelivery: FunctionComponent<Props> = ({ deliveryDates }) => {
  const intl = useIntl();
  const dates = formatDeliveryDates(deliveryDates, intl);

  const getDeliveryTypeTranslation = (deliveryType: string, text: string) => {
    return intl.formatMessage(
      { id: "cheerz_CartEstimatedDelivery_delivery" },
      {
        title: (
          <span className="CartEstimatedDelivery-description-line-text-deliveryType">
            {intl.formatMessage({
              id: `cheerz_CartEstimatedDelivery_delivery_${deliveryType}`,
            })}
          </span>
        ),
        text,
      }
    );
  };

  return (
    <div className="CartEstimatedDelivery">
      <div className="CartEstimatedDelivery-title">
        {intl.formatMessage({
          id: "cheerz_CartEstimatedDelivery_title",
        })}
      </div>
      <div className="CartEstimatedDelivery-description">
        <div className="CartEstimatedDelivery-description-line">
          <IconTruck />
          <div className="CartEstimatedDelivery-description-line-text">
            {getDeliveryTypeTranslation("standard", dates)}
          </div>
        </div>
        <div className="CartEstimatedDelivery-description-line">
          <IconRocket />
          <div className="CartEstimatedDelivery-description-line-text">
            {getDeliveryTypeTranslation(
              "express",
              intl.formatMessage({
                id: "cheerz_CartEstimatedDelivery_delivery_express_explanation",
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartEstimatedDelivery;
